import { useRouter } from 'next/router';
import Contributors from '@/components/ui/contributors/Contributors';
import Contributor from '@/components/ui/contributors/Contributor';
import Layout from '@/components/layout/Layout';

export default function Index() {
  const router = useRouter();
  const username = router.query.username?.[0];

  return (
    <Layout
      gradientBg
      className="md:h-screen"
      containerClassName="px-3 md:px-0">
      {username ? <Contributor username={username} /> : <Contributors />}
    </Layout>
  );
}
